import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const Footer = ({
  tableManager
}) => {
  const {
    config: {
      isPaginated,
      showRowsInformation,
      pageSizes,
      components: {
        Information,
        PageSize,
        Pagination
      },
      additionalProps: {
        footer: additionalProps = {}
      }
    },
    rowsApi: {
      totalRows
    },
    rowSelectionApi: {
      selectedRowsIds
    },
    paginationApi: {
      page,
      pageSize,
      setPage,
      setPageSize,
      pageRows
    }
  } = tableManager;
  const classNames = ('rgt-footer ' + (additionalProps.className || '')).trim();
  return /*#__PURE__*/_jsxs("div", { ...additionalProps,
    className: classNames,
    children: [showRowsInformation !== false ? /*#__PURE__*/_jsx(Information, {
      totalCount: totalRows,
      pageSize: pageSize,
      pageCount: pageRows.length,
      selectedCount: selectedRowsIds.length,
      tableManager: tableManager
    }) : /*#__PURE__*/_jsx("span", {}), isPaginated ? /*#__PURE__*/_jsxs("div", {
      className: "rgt-footer-right-container",
      children: [/*#__PURE__*/_jsx(PageSize, {
        value: pageSize,
        onChange: setPageSize,
        options: pageSizes,
        tableManager: tableManager
      }), /*#__PURE__*/_jsx(Pagination, {
        page: page,
        onChange: setPage,
        tableManager: tableManager
      })]
    }) : null]
  });
};

export default Footer;